"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.basicAuthRequest = exports.jsonToQueryString = exports.stripTrailingSlash = void 0;
const axios_1 = require("axios");
// import { HTTPError } from './errors';
/**
 * Remove trailing slash from given string,
 *
 * Ex:
 *  input: 'https://localhost/'
 *  output: 'https://localhost'
 *
 * @param {string} str String to convert
 *
 * @return {string} Stripped string.
 */
exports.stripTrailingSlash = str => {
  return str.endsWith('/') ? str.slice(0, -1) : str;
};
/**
 * Given a JSON object, create query string.
 *
 * Ex:
 *   input: { limit: 1, offset: 2 }
 *   output: 'limit=1&offset=2'
 *
 * @param {object} obj Key-value pairs for query string.
 *
 * @return {string} Query string.
 */
exports.jsonToQueryString = function () {
  let obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(obj).map(key => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
  }).join('&');
};
const makeRequest = function makeHTTPRequest(options, callBack) {
  return __awaiter(this, void 0, void 0, function* () {
    const request = yield axios_1.default.request(options);
    callBack(new Date().valueOf());
    return request;
  });
};
// /**
//  * Make a request using Basic Authorization header. Return the response as JSON.
//  *
//  * @param {string} uri Url to make the request to.
//  * @param {string} method Method of the request. Ex: GET, POST, PATCH ...
//  * @param {string} authKey Authorization string to be used in header.
//  * @param {{}} body Body of the request.
//  *
//  * @return {Promise<request.ResponseAsJSON>}
//  */
exports.basicAuthRequest = function basicAuthHTTPRequest(url, method, headersCfg, data) {
  return __awaiter(this, void 0, void 0, function* () {
    const config = {
      url,
      method,
      data,
      headers: {
        partnerid: '',
        appid: '',
        momoid: '',
        cskhtoken: '',
        osid: '',
        ostoken: '',
        locale: '',
        platform: '',
        version: '',
        deviceModel: ''
      }
    };
    // if (headers.token) {
    //   config.headers.Authorization = `Bearer ${headers.token}`;
    // }
    if (headersCfg.partnerid) {
      config.headers.partnerid = headersCfg.partnerid;
    }
    if (headersCfg.appid) {
      config.headers.appid = headersCfg.appid;
    }
    if (headersCfg.momoid) {
      config.headers.momoid = headersCfg.momoid;
    }
    if (headersCfg.cskhtoken) {
      config.headers.cskhtoken = headersCfg.cskhtoken;
    }
    if (headersCfg.osid) {
      config.headers.osid = headersCfg.osid;
    }
    if (headersCfg.ostoken) {
      config.headers.ostoken = headersCfg.ostoken;
    }
    if (headersCfg.platform) {
      config.headers.platform = headersCfg.platform;
    }
    if (headersCfg.version) {
      config.headers.version = headersCfg.version;
    }
    if (headersCfg.token) {
      config.headers.Authorization = `Bearer ${headersCfg.token}`;
    }
    if (headersCfg.locale) {
      config.headers.locale = headersCfg.locale;
    }
    if (headersCfg.file) {
      config.headers['Content-Type'] = 'multipart/form-data';
    }
    if (headersCfg.refcode) {
      config.headers.refcode = headersCfg.refcode;
    }
    if (headersCfg.deviceModel) {
      config.headers.deviceModel = headersCfg.deviceModel;
    }
    const startTime = new Date().valueOf();
    const sendRequest = makeRequest(config, a => {
      if (headersCfg.timeOut) {
        if (Math.abs(a - startTime) > headersCfg.timeOut) {
          if (headersCfg.onTimeOut) headersCfg.onTimeOut(Object.assign(Object.assign({}, config), {
            timeResponse: Math.abs(a - startTime)
          }));
        }
      }
    });
    return sendRequest;
  });
};